/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import has from"../../../core/has.js";const e=has("esri-mobile")?64:128,o=e/128,r=Math.ceil(Math.sqrt(e)),t=(e+2)*r,s=1e5,i=128,a=t/1560;export{t as atlasSize,o as textureScale,r as tileRows,e as tileSize,a as weatherMapScale,s as weatherMapSize,i as weatherTileSize};
